export default function storeCredit(state = {}, action) {
  switch (action.type) {
    case 'AVAILABLE_STORE_CREDIT':
      return {
        ...state,
        ...action.storeCredit
      };
    case 'LINKING_JIO_PRIME': {
      return { ...state, jioPrimeLinking: action.jioPrimeLinking };
      break;
    }
    case 'UPDATE_STORE_CREDIT_FOR_JIO_PRIME':
      let {
        jioPrimeEnabled = false,
        jioPrimeRegistered = false,
        jioPrimeLinked = false
      } = action.jioprimeConfig;
      return {
        ...state,
        jioPrimeEnabled,
        jioPrimeRegistered,
        jioPrimeLinked,
        jioPrimeLinking: jioPrimeLinked
      };
      break;

    default:
      return state;
  }
}
